import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/topbar";
import Sidebar from "../components/sidebar";
import Footer from "../components/footer";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${BASE_URL}admin/getdata/get_adminfeedback.php`;

const Feedbacks = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [comments, setComments] = useState("");
  const [author, setAuthor] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  /* ================= FETCH ================= */
  const fetchFeedbacks = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}?action=list`);
      if (res.data.success) {
        setFeedbacks(res.data.data);
      }
    } catch (err) {
      console.error(err);
      setMessage("Error loading feedbacks");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!comments.trim() || !author.trim()) {
      setMessage("All fields are required");
      return;
    }

    try {
      if (editingId === null) {
        // CREATE
        await axios.post(`${API_URL}?action=create`, {
          comments,
          author,
        });
        setMessage("Feedback added successfully");
      } else {
        // UPDATE (PUT)
        await axios.put(`${API_URL}?action=update`, {
          id: editingId,
          comments,
          author,
        });
        setMessage("Feedback updated successfully");
      }

      setComments("");
      setAuthor("");
      setEditingId(null);
      fetchFeedbacks();

    } catch (err) {
      console.error(err);
      setMessage("Save failed");
    }
  };

  /* ================= EDIT ================= */
  const handleEdit = (item) => {
    setComments(item.comments);
    setAuthor(item.author);
    setEditingId(item.fid);
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this feedback?")) return;

    try {
      await axios.delete(`${API_URL}?action=delete`, {
        data: { id },
      });
      setMessage("Feedback deleted");
      fetchFeedbacks();
    } catch (err) {
      console.error(err);
      setMessage("Delete failed");
    }
  };

  return (
    <div className="header-light sidebar-dark sidebar-expand">
      <Topbar />
      <div className="content-wrapper">
        <Sidebar />

        <main className="main-wrapper clearfix">
          <div className="widget-list container mt-4">

            <h4>Manage Feedbacks</h4>

            {/* FORM */}
            <div className="card mt-3">
              <div className="card-header">
                {editingId === null ? "Add Feedback" : "Edit Feedback"}
              </div>

              <div className="card-body">
                {message && (
                  <div className="alert alert-info py-2">
                    {message}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label>Comments</label>
                    <textarea
                      className="form-control"
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                      placeholder="Enter feedback comments"
                      rows="3"
                    />
                  </div>

                  <div className="mb-3">
                    <label>Author Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={author}
                      onChange={(e) => setAuthor(e.target.value)}
                      placeholder="Enter author name"
                    />
                  </div>

                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={loading}
                  >
                    {editingId === null ? "Submit" : "Update"}
                  </button>
                </form>
              </div>
            </div>

            {/* LIST */}
            <div className="card mt-4">
              <div className="card-header">View Feedbacks</div>
              <div className="card-body p-0">

                {loading ? (
                  <p className="p-3 mb-0">Loading...</p>
                ) : (
                  <table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Comments</th>
                        <th>Author</th>
                        <th style={{ width: "140px" }}>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {feedbacks.length > 0 ? (
                        feedbacks.map((item, index) => (
                          <tr key={item.fid}>
                            <td>{index + 1}</td>
                            <td>{item.comments}</td>
                            <td>{item.author}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-secondary me-2"
                                onClick={() => handleEdit(item)}
                              >
                                ✏️
                              </button>

                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() =>
                                  handleDelete(item.fid)
                                }
                              >
                                🗑
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No feedbacks found
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>
                )}
              </div>
            </div>

          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default Feedbacks;